import * as FeeConstants from "../constants/fee.constant";
import { Loading } from "../utils/helpers/constants";
import { modifyList, deleteItemHelper } from "../utils/helpers/dataHelper";

const initialState = {
  fees: [],
  fee: {},
  feeList: [],
  outstandingAlumniFee: 0,
  outstandingAlumniFeeList: [],
  feeLoading: false,
  feeStatusLoading: false,
  deleteStatusState: false,
};

const setLoading = (state, action) => {
  const actionLoading = { ...state.feeStatusLoading };
  const { loading, id } = action.payload;
  actionLoading[id] = loading;
  return actionLoading;
};

const feeReducer = (state = initialState, action) => {
  const currentFeeList = [...state.feeList];
  switch (action.type) {
    case FeeConstants.CREATE_FEE_REQUEST:
      return { ...state, feeLoading: Loading.FETCHING };
    case FeeConstants.CREATE_FEE_SUCCESS:
      return {
        ...state,
        fee: action.payload,
        feeLoading: Loading.SUCCESS,
      };
    case FeeConstants.CREATE_FEE_FAILURE:
      return { ...state, feeLoading: Loading.ERROR };

    case FeeConstants.FETCH_FEE_TYPE_REQUEST:
      return { ...state, feeLoading: Loading.FETCHING };
    case FeeConstants.FETCH_FEE_TYPE_SUCCESS:
      return {
        ...state,
        fee: action.payload,
        feeLoading: Loading.SUCCESS,
      };
    case FeeConstants.FETCH_FEE_TYPE_FAILURE:
      return { ...state, feeLoading: Loading.ERROR };

    case FeeConstants.FETCH_ALL_FEE_REQUEST:
      return { ...state, feeLoading: Loading.FETCHING };
    case FeeConstants.FETCH_ALL_FEE_SUCCESS:
      return {
        ...state,
        feeList: action.payload.feeList,
        feeLoading: Loading.SUCCESS,
      };
    case FeeConstants.FETCH_ALL_FEE_FAILURE:
      return { ...state, feeLoading: Loading.ERROR };

    case FeeConstants.ACTIVATE_OR_DEACTIVATE_FEE_REQUEST:
      return {
        ...state,
        feeStatusLoading: setLoading(state, action),
      };
    case FeeConstants.ACTIVATE_OR_DEACTIVATE_FEE_SUCCESS:
      const feeList = [...state.feeList];
      const modifiedList = modifyList(
        feeList,
        action.payload.id,
        "id",
        "active"
      );
      return {
        ...state,
        feeList: modifiedList,
        feeStatusLoading: setLoading(state, action),
      };
    case FeeConstants.ACTIVATE_OR_DEACTIVATE_FEE_FAILURE:
      return {
        ...state,
        feeStatusLoading: setLoading(state, action),
      };

    case FeeConstants.DELETE_FEE_REQUEST:
      return {
        ...state,
        deleteStatusState: setLoading(state, action),
      };
    case FeeConstants.DELETE_FEE_SUCCESS:
      const newList = deleteItemHelper(currentFeeList, action.payload.id, "id");
      return {
        ...state,
        feeList: newList,
        deleteStatusState: setLoading(state, action),
      };
    case FeeConstants.DELETE_FEE_FAILURE:
      return {
        ...state,
        deleteStatusState: setLoading(state, action),
      };

    case FeeConstants.GET_OUTSTANDING_ALUMNI_FEE_REQUEST:
      return {
        ...state,
        feeLoading: action.payload.loading,
      };
    case FeeConstants.GET_OUTSTANDING_ALUMNI_FEE_SUCCESS:
      console.log("action.payload ==> ", action.payload);
      console.log("action.payload loafin ==> ", action.payload.loading);
      return {
        ...state,
        feeLoading: action.payload.loading,
        outstandingAlumniFee: action.payload.data.totalFee,
        outstandingAlumniFeeList: action.payload.data.feeResponseList,
      };
    case FeeConstants.GET_OUTSTANDING_ALUMNI_FEE_FAILURE:
      return {
        ...state,
        feeLoading: action.payload.loading,
      };

    default:
      return state;
  }
};

export default feeReducer;
